import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ProHelp, ProHelpDrawer } from '@ant-design/pro-components';
import { useBoolean } from 'ahooks';
import React from 'react';
export var GlobalDocument = function GlobalDocument(properties) {
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    viewing = _useBoolean2[0],
    viewingAction = _useBoolean2[1];
  return /*#__PURE__*/React.createElement(ProHelp, _extends({
    dataSource: [{
      title: '常见问题',
      key: 'default',
      children: []
    }]
  }, properties), properties.trigger && /*#__PURE__*/React.cloneElement(properties.trigger, {
    onClick: viewingAction.setTrue
  }), /*#__PURE__*/React.createElement(ProHelpDrawer, {
    drawerProps: {
      open: viewing,
      rootStyle: {
        zIndex: 99,
        top: 48 + 40,
        height: 'calc(100% - (48px + 40px))'
      },
      mask: false,
      afterOpenChange: viewingAction.set,
      getContainer: function getContainer() {
        return document.querySelector('main');
      }
    }
  }));
};